import { useCallback, useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import HOC from '../../components/HOC/HOC';
import addjob from '../../css/style.module.css';

import img2 from '../../assest/loading1.gif';
import ImageUpload from '../../components/ImageUpload/ImageUpload';
import { getApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';
import { formatDate1 } from '../../utils/utils';

const StaffProfile = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [loadingjob, setLoadingJob] = useState(false);
  const [jobsdata, setJobsData] = useState([]);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    dateOfBirth: '',
    gender: '',
    businessStreet1: '',
    businessStreet2: '',
    businessTown: '',
    businessLandMark: '',
    businessCity: '',
    businessCountry: '',
    businessPostCode: '',
    subcategoryId: [],
    travelingDistance: 0,
    fromHourRange: 0,
    toHourRange: 0,
    bankName: '',
    bankAccountNumber: '',
    ifscCode: '',
    role: '',
    description: '',
    gstNo: '',
  });

  const [imagePreviews, setImagePreviews] = useState({
    aadharCard: '',
    panCard: '',
    addressProof: '',
    tenthMarkSheet: '',
    twelfthMarkSheet: '',
    graduationMarkSheet: '',
    postGraduationMarkSheet: '',
    policeVerification: '',
    image: '',
  });

    const fetchStaffData = useCallback(async () => {
      console.log(id)
    if (id) {
      await getApi(endPoints.getStaffbyid(id), {
        setResponse: (response) => {
          const data = response?.data || {};
          const docunent = response?.docunent || {};
          setFormData({
            firstName: data.firstName || '',
            lastName: data.lastName || '',
            phone: data.phone || '',
            email: data.email || '',
            dateOfBirth: data.dateOfBirth,
            gender: data.gender || '',
            businessStreet1: data.businessStreet1 || '',
            businessStreet2: data.businessStreet2 || '',
            businessTown: data.businessTown || '',
            businessLandMark: data.businessLandMark || '',
            businessCity: data.businessCity || '',
            businessCountry: data.businessCountry || '',
            businessPostCode: data.businessPostCode || '',
            subcategoryId: data.subcategoryId || [], // Assuming jobType is an array
            travelingDistance: data.travelingDistance || 0,
            fromHourRange: data.fromHourRange || 0,
            toHourRange: data.toHourRange || 0,
            bankName: data.bankName || '',
            bankAccountNumber: data.bankAccountNumber || '',
            ifscCode: data.ifscCode || '',
            role: data.role || '',
            description: data.description || '',
            gstNo: data.gstNo || '',
          });
          setImagePreviews({
            aadharCard: docunent?.aadharCard || '',
            panCard: docunent?.panCard || '',
            addressProof: docunent?.addressProof || '',
            tenthMarkSheet: docunent?.tenthMarkSheet || '',
            twelfthMarkSheet: docunent?.twelfthMarkSheet || '',
            graduationMarkSheet: docunent?.graduationMarkSheet || '',
            postGraduationMarkSheet: docunent?.postGraduationMarkSheet || '',
            policeVerification: docunent?.policeVerification || '',
            image: data.image || '',
          });
        },
        setLoading,
        errorMsg: 'Failed to fetch data!',
      });
    }
  }, [id]);

  const fetchData = async () => {
    await getApi(endPoints.getallsubcategory, {
      setResponse: setJobsData,
      setLoading: setLoadingJob,
      errorMsg: 'Failed to fetch jobs!',
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    fetchStaffData();
  }, [fetchStaffData]);

  const MultiSelectCheckbox = ({ options, selectedValues, onSelect, onRemove, placeholder }) => {
    const [isOpen, setIsOpen] = useState(false);
    const wrapperRef = useRef(null);

    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    useEffect(() => {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
      <div className={addjob.multiSelectWrapper} ref={wrapperRef}>
        <div
          className={addjob.selectInput}
          // onClick={() => setIsOpen(!isOpen)}
        >
          {placeholder}
        </div>

        {isOpen && (
          <div className={addjob.dropdown}>
            {options?.map((option) => (
              <label key={option.value || option?._id} className={addjob.optionItem}>
                <input
                  type="checkbox"
                  checked={selectedValues?.includes(option.value || option?._id)}
                  onChange={(e) =>
                    e.target.checked
                      ? onSelect(option.value || option?._id)
                      : onRemove(option.value || option?._id)
                  }
                />
                {option.label || option?.name}
              </label>
            ))}
          </div>
        )}

        <div className={addjob.selectedTags}>
          {selectedValues?.map((value) => {
            const option = options?.find((opt) => (opt.value || opt._id) === value);
            return (
              <div key={value} className={addjob.tag}>
                <span>{option?.label || option?.name}</span>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <>
      <div className={addjob.jobmanagementCotainer}>
        <div className={addjob.jobtoppart}>
          <div className={addjob.pagetitle}>
            <h6>Staff Profile</h6>
          </div>
        </div>

        <div className={addjob.addjobcontainer}>
          <div className={addjob.addjobsubcontainer}>
            <div className={addjob.addjobtopic}>
              <h6>Staff Details</h6>
            </div>
            {loading ? (
              <div className={addjob.loadingnormal}>
                <img src={img2} alt="Loading" width={100} height={100} />
              </div>
            ) : (
              <>
                <div className={addjob.addcontactdetails}>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">First Name</label>
                    <input
                      type="text"
                      name="firstName"
                      placeholder="Enter first name"
                      value={formData.firstName}
                      readOnly
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Last Name</label>
                    <input
                      type="text"
                      placeholder="Enter last name"
                      name="lastName"
                      value={formData.lastName}
                      readOnly
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Email</label>
                    <input
                      type="email"
                      placeholder="Enter email"
                      name="email"
                      value={formData.email}
                      readOnly
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Number</label>
                    <input
                      type="text"
                      placeholder="Enter number"
                      name="phone"
                      value={formData.phone}
                      readOnly
                    />
                  </div>
                  {/* <div className={addjob.addjobinputs}>
                                        <label htmlFor="">Role</label>
                                        <input
                                            type="text"
                                            placeholder='Enter role'
                                            name="role"
                                            value={formData.role}
                                        />
                                    </div> */}
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Date Of Birth</label>
                    <input
                      type="date"
                      value={formatDate1(formData.dateOfBirth)}
                      name="dateOfBirth"
                      readOnly
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Gender</label>
                    <input
                      type="text"
                      placeholder="Enter gender"
                      name="gender"
                      value={formData.gender}
                      readOnly
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Business Street1</label>
                    <input
                      type="text"
                      placeholder="Enter the business street1"
                      name="businessStreet1"
                      value={formData.businessStreet1}
                      readOnly
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Business Street2</label>
                    <input
                      type="text"
                      placeholder="Enter the business street2"
                      name="businessStreet2"
                      value={formData.businessStreet2}
                      readOnly
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Business Town</label>
                    <input
                      type="text"
                      placeholder="Enter the business town"
                      name="businessTown"
                      value={formData.businessTown}
                      readOnly
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Business LandMark</label>
                    <input
                      type="text"
                      placeholder="Enter the business landmark"
                      name="businessLandMark"
                      value={formData.businessLandMark}
                      readOnly
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Business City</label>
                    <input
                      type="text"
                      placeholder="Enter the business city"
                      name="businessCity"
                      value={formData.businessCity}
                      readOnly
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Business Country</label>
                    <input
                      type="text"
                      placeholder="Enter the business country"
                      name="businessCountry"
                      value={formData.businessCountry}
                      readOnly
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Business PostCode</label>
                    <input
                      type="text"
                      placeholder="Enter the business postcode"
                      name="businessPostCode"
                      value={formData.businessPostCode}
                      readOnly
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Job Role</label>
                    <MultiSelectCheckbox
                      options={jobsdata?.data}
                      selectedValues={formData.subcategoryId?.map((sub) => sub._id)}
                      onSelect={(value) =>
                        setFormData((prev) => ({
                          ...prev,
                          subcategoryId: [
                            ...(prev.subcategoryId || []),
                            jobsdata?.data?.find((job) => job._id === value),
                          ],
                        }))
                      }
                      onRemove={(value) =>
                        setFormData((prev) => ({
                          ...prev,
                          subcategoryId: prev.subcategoryId.filter((sub) => sub._id !== value),
                        }))
                      }
                      placeholder="Select subcategory..."
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Traveling Distance</label>
                    <input
                      type="number"
                      placeholder="Enter the traveling distance"
                      name="travelingDistance"
                      value={formData.travelingDistance}
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">From Hour Range</label>
                    <input
                      type="number"
                      placeholder="Enter the from hour range"
                      name="fromHourRange"
                      value={formData.fromHourRange}
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">To Hours Range</label>
                    <input
                      type="number"
                      placeholder="Enter the to hour Range"
                      name="toHourRange"
                      value={formData.toHourRange}
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Bank Name</label>
                    <input
                      type="text"
                      placeholder="Enter the bank name"
                      name="bankName"
                      value={formData.bankName}
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">Bank Account Number</label>
                    <input
                      type="text"
                      placeholder="Enter the bank account number"
                      name="bankAccountNumber"
                      value={formData.bankAccountNumber}
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">IFSC Code</label>
                    <input
                      type="text"
                      placeholder="Enter the IFSC Code"
                      name="ifscCode"
                      value={formData.ifscCode}
                    />
                  </div>
                  <div className={addjob.addjobinputs}>
                    <label htmlFor="">GST No</label>
                    <input
                      type="text"
                      placeholder="Enter the gstNo"
                      name="gstNo"
                      value={formData.gstNo}
                    />
                  </div>
                </div>
                <div className={addjob.addjobinputs}>
                  <label htmlFor="">Description</label>
                  <textarea
                    placeholder="description"
                    value={formData.description}
                    name="description"
                  />
                </div>
                <div className={addjob.addjobtopic}>
                  <h6>Documents</h6>
                </div>
                <div className={addjob.addcontactdetails}>
                  <ImageUpload
                    label="Profile Image*"
                    name="image"
                    imagePreview={imagePreviews.image}
                    clear="dahd"
                    mode="read"
                  />
                  <ImageUpload
                    label="Address Proof Image*"
                    name="addressProof"
                    imagePreview={imagePreviews.addressProof}
                    clear="dahd"
                    mode="read"
                  />
                  <ImageUpload
                    label="Aadhar Card*"
                    name="aadharCardFront"
                    imagePreview={imagePreviews.aadharCard}
                    clear="dahd"
                    mode="read"
                  />
                  <ImageUpload
                    label="Pan Card*"
                    name="panCardLicensePassport"
                    imagePreview={imagePreviews.panCard}
                    clear="dahd"
                    mode="read"
                  />

                  <ImageUpload
                    label="Tenth MarkSheet*"
                    name="tenthMarkSheet"
                    imagePreview={imagePreviews.tenthMarkSheet}
                    clear="dahd"
                    mode="read"
                  />
                  <ImageUpload
                    label="Twelfth MarkSheet*"
                    name="twelfthMarkSheet"
                    imagePreview={imagePreviews.twelfthMarkSheet}
                    clear="dahd"
                    mode="read"
                  />

                  <ImageUpload
                    label="Graduation MarkSheet*"
                    name="graduationMarkSheet"
                    imagePreview={imagePreviews.graduationMarkSheet}
                    clear="dahd"
                    mode="read"
                  />
                  <ImageUpload
                    label="PostGraduation MarkSheet*"
                    name="postGraduationMarkSheet"
                    imagePreview={imagePreviews.postGraduationMarkSheet}
                    clear="dahd"
                    mode="read"
                  />

                  <ImageUpload
                    label="Police Verification Image*"
                    name="policeVerification"
                    imagePreview={imagePreviews.policeVerification}
                    clear="dahd"
                    mode="read"
                  />
                </div>
              </>
            )}
          </div>

          <div className={addjob.addjobbutton}>
            <div className={addjob.rightbuttons}>
              <button onClick={() => navigate(-1)}>Cancel</button>
            </div>
            <div className={addjob.rightbuttons}>
              <Link to={`/staff-management/registered/editstaff/${id}`}>
                <button style={{ background: '#F05423' }}>Edit</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HOC(StaffProfile);
